/* Formwork Tools theme - small, dependency-free enhancements */
(function () {
  'use strict';

  // Product page: variant buttons, quantity, sticky bar
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    var dataEl = section.querySelector('[data-product-json]');
    var data = null;
    try { data = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { data = null; }
    var idInput = section.querySelector('[data-variant-id]');
    var buttons = section.querySelectorAll('[data-add-button]');
    var addText = (window.FT && window.FT.addToCart) || 'Add to cart';
    var soldOutText = (window.FT && window.FT.soldOut) || 'Currently out of stock';

    function selectedOptions() {
      return Array.prototype.map.call(section.querySelectorAll('.variant-picker'), function (fs) {
        var c = fs.querySelector('[data-option-input]:checked');
        return c ? c.value : null;
      });
    }
    function markValues(opts) {
      // Mark each option value unavailable if no in-stock variant has it (given the other selections)
      section.querySelectorAll('.variant-picker').forEach(function (fs, i) {
        fs.querySelectorAll('[data-option-input]').forEach(function (inp) {
          var ok = data.variants.some(function (x) {
            return x.available && x.options.every(function (o, n) { return n === i ? o === inp.value : (opts[n] == null || o === opts[n]); });
          });
          var lab = section.querySelector('label[for="' + inp.id + '"]');
          if (!lab) return;
          lab.classList.toggle('is-unavailable', !ok);
          var st = lab.querySelector('[data-stock-label]');
          if (st) st.hidden = ok;
        });
      });
    }
    function onVariantChange(e) {
      if (!data) return;
      var opts = selectedOptions();
      markValues(opts);
      var v = data.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      section.querySelectorAll('.variant-picker').forEach(function (fs, i) {
        var lab = fs.querySelector('[data-option-value]');
        if (lab) lab.textContent = opts[i] || '';
      });
      var available = !!(v && v.available);
      if (v && idInput) idInput.value = v.id;
      section.querySelectorAll('[data-price]').forEach(function (el) { if (v) el.textContent = v.price; });
      var sticky = section.querySelector('[data-sticky-price]');
      if (sticky && v) sticky.textContent = v.price;
      var compareEl = section.querySelector('[data-compare]');
      if (compareEl) { compareEl.textContent = (v && v.compare) || ''; compareEl.hidden = !(v && v.compare); }
      var msg = section.querySelector('[data-stock-msg]');
      if (msg) msg.hidden = available;
      var buyNow = section.querySelector('[data-buy-now]');
      if (buyNow) buyNow.hidden = !available;
      buttons.forEach(function (b) {
        b.disabled = !available;
        var l = b.querySelector('[data-add-label]');
        if (l) l.textContent = available ? addText : soldOutText;
      });
      if (e && v && v.media_id) section.dispatchEvent(new CustomEvent('gallery:show', { detail: { mediaId: String(v.media_id) } }));
      if (e && v && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    section.querySelectorAll('[data-option-input]').forEach(function (i) { i.addEventListener('change', onVariantChange); });
    if (data && section.querySelector('[data-option-input]')) onVariantChange(null); // sync initial state

    var qty = section.querySelector('[data-qty]');
    var tierRows = Array.prototype.slice.call(section.querySelectorAll('[data-tier-min]'));
    function highlightTier(n) {
      var active = null;
      tierRows.forEach(function (r) { if (n >= parseInt(r.dataset.tierMin, 10)) active = r; });
      tierRows.forEach(function (r) { r.classList.toggle('is-active', r === active); });
    }
    if (qty) {
      var input = qty.querySelector('input');
      var minQ = Math.max(1, parseInt(input.dataset.min, 10) || 1);
      var stepQ = Math.max(1, parseInt(input.dataset.step, 10) || 1);
      // Clamp to the minimum and round up to the next whole step above the minimum
      var clamp = function (n) {
        n = parseInt(n, 10);
        if (!n || n < minQ) n = minQ;
        var over = (n - minQ) % stepQ;
        if (over) n += stepQ - over;
        return n;
      };
      var sync = function () {
        input.value = clamp(input.value);
        highlightTier(parseInt(input.value, 10));
        var minus = qty.querySelector('[data-qty-minus]');
        if (minus) minus.disabled = parseInt(input.value, 10) <= minQ;
      };
      qty.addEventListener('click', function (e) {
        var n = clamp(input.value);
        if (e.target.closest('[data-qty-minus]')) input.value = Math.max(minQ, n - stepQ);
        if (e.target.closest('[data-qty-plus]')) input.value = n + stepQ;
        sync();
      });
      input.addEventListener('change', sync);
      input.addEventListener('blur', sync);
      input.addEventListener('input', function () { var n = parseInt(input.value, 10); if (n) highlightTier(n); });
      if (form) form.addEventListener('submit', sync, true);
      sync();
    }

    // Sticky mobile bar: show once the main price row scrolls out of view
    var bar = section.querySelector('[data-sticky-buy]');
    var priceRow = section.querySelector('[data-main-price]');
    if (bar && priceRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(priceRow);
    } else if (bar) { bar.classList.add('is-visible'); }
    if (form) form.addEventListener('submit', function () { buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); }); });
  });

  // Product gallery: swipe (scroll-snap), arrows, thumbnails, keyboard
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('.gallery__slide'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
    var counter = g.querySelector('[data-gallery-current]');
    var current = 0;
    if (!track || slides.length === 0) return;

    function setActive(i) {
      if (i === current && thumbs[i] && thumbs[i].classList.contains('is-active')) return;
      current = i;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = i + 1;
      slides.forEach(function (s, n) {
        if (n !== i) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.galleryThumb, 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'Home') { e.preventDefault(); go(0); }
      if (e.key === 'End') { e.preventDefault(); go(slides.length - 1); }
    });
    var section = g.closest('[data-product-section]');
    if (section) section.addEventListener('gallery:show', function (e) {
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === e.detail.mediaId; });
      if (idx > -1) go(idx);
    });
    setActive(0);
  });

  // Auto-submit collection sort
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  // Contact page: preselect enquiry type from ?enquiry=trade|bulk
  var enquiry = document.querySelector('[data-enquiry-select]');
  if (enquiry) {
    var type = new URLSearchParams(window.location.search).get('enquiry');
    var map = { trade: 'Trade account enquiry', bulk: 'Bulk order quote', order: 'Order support' };
    if (type && map[type]) enquiry.value = map[type];
  }

  // Login page: toggle password recovery
  var recover = document.querySelector('[data-recover]');
  var login = document.querySelector('[data-login]');
  function showRecover(show) {
    if (!recover || !login) return;
    recover.hidden = !show;
    login.hidden = show;
    var focusTarget = (show ? recover : login).querySelector('input[type="email"]');
    if (focusTarget) focusTarget.focus();
  }
  document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      showRecover(a.getAttribute('href') === '#Recover');
    });
  });
  if (window.location.hash === '#Recover') showRecover(true);

  // Address delete confirmation
  document.querySelectorAll('form[data-confirm]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.confirm(f.dataset.confirm)) e.preventDefault();
    });
  });

  // Address country default
  document.querySelectorAll('select[data-default]').forEach(function (s) {
    var v = s.dataset.default;
    for (var i = 0; i < s.options.length; i++) {
      if (s.options[i].value === v) { s.selectedIndex = i; break; }
    }
  });

  // Close mobile nav on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-nav][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });
})();
